export default "__VITE_ASSET__2yJyrBAj__"